import { ClosableModal } from '@Components/shared/dialogs/ClosableModal';
import { CreateAviatorPermissionForm } from './CreateAviatorPermissionForm';
import { useAviatorPermissions } from '@Modal/hooks/aviatorRoles/useAviatorPermissions';

export const CreateAviatorPermissionModalDialog = () => {
  const { showCreateAviatorPermissionForm, handleCloseCreateAviatorPermissionModalDialog } =
    useAviatorPermissions();

  return (
    <>
      {showCreateAviatorPermissionForm && (
        <ClosableModal
          name="CreateAviatorPermission"
          title="Create Permission"
          open={showCreateAviatorPermissionForm}
          onClose={handleCloseCreateAviatorPermissionModalDialog}
          sx={{ width: '592px' }}
        >
          <CreateAviatorPermissionForm />
        </ClosableModal>
      )}
    </>
  );
};
